import { DocumentServicesObject, CompRef } from '@wix/document-services-types';
import type { EditorPointer, EditorPointerAPI } from '@wix/editorx-core-api';
import { ManifestServices } from '@wix/editor-platform-manifest-services';

import { handleErrors } from '../../utils/builderServices';
import { ManifestUrlResolver } from '../manifestUrlResolverService';
import { initManifestServices } from './manifestServices';
import { loadInitialDataFromEERegistry } from './editorElementsRegistry';
import { IExperimentsApiAdapter } from './types';
import { PanelsStore } from './panelsStore';
import { builderServicesPact } from './builderServicesPact';

export function initBuilderServices(
  documentServicesAPI: DocumentServicesObject,
  experimentsAPI: IExperimentsApiAdapter,
  isBuilderServicesEnabled: boolean,
  editorPointerAPI?: EditorPointerAPI,
) {
  if (!isBuilderServicesEnabled || !editorPointerAPI) {
    return builderServicesPact;
  }

  const panelsStore = new PanelsStore(editorPointerAPI);
  const URLResolver = new ManifestUrlResolver(documentServicesAPI);

  const manifestServices = new ManifestServices(URLResolver);

  const initialLoad = loadInitialDataFromEERegistry(
    window.serviceTopology,
    experimentsAPI,
    {
      setManifest: manifestServices.setManifest,
    },
  ).catch(handleErrors);

  manifestServices.setInitialLoad(initialLoad);

  const manifestServicesAPI = initManifestServices(
    documentServicesAPI,
    editorPointerAPI,
    manifestServices,
    panelsStore,
  );

  return {
    manifest: manifestServicesAPI,
    panels: {
      getDesignPanel: (editorPointer: EditorPointer<CompRef>) => {
        return panelsStore.getPanel(editorPointer, 'design');
      },
    },
  };
}
